import Tips from "@/utils/utils/Tips";
export default {
  data() {
    return {
      isEdit: false, // 是否为编辑状态
      showFormDialog: false, // 是否显示表单dialog
      formDataOri: {}, // 表单数据初始值
      formData: {},  // 表单数据model
      formRules: {},   // 表单检验rules
      submitData: {},  // 最终提交数据
      adddApi: null, // 添加提交api
      editApi: null, // 编辑提交api
      deleteApi: null, // 删除提交api
      addSuccessMsg: '',  // 添加成功提示信息
      editSuccessMsg: '', // 编辑成功提示信息
      deleteSuccessMsg: '删除记录成功', // 编辑成功提示信息
      deleteKey: 'id',  // 删除记录传的key
      showExportDialog: false, // 是否显示导出对话框
    };
  },

  methods: {
    doAdd() {
      this.formData = this.$_.cloneDeep(this.formDataOri)
      this.isEdit = false
      this.showFormDialog = true
      if (this.doAddExtra) {
        this.doAddExtra()
      }
    },

    doEdit(editItem) {
      this.isEdit = true
      if (this.dealEditItem) {
        // console.log('ddddddd')
        this.formData = this.dealEditItem(editItem)
      } else {
        this.formData = this.$_.cloneDeep(editItem)
      }
      if (this.doEditExtra) {
        this.doEditExtra(editItem)
      }
      this.showFormDialog = true
    },

    openFormDialog() {
      this.showFormDialog = true
    },

    closeFormDialog() {
      this.showFormDialog = false
    },

    submitForm() {
      if (this.beforeValidate) {
        this.beforeValidate()
      }

      this.$refs.myForm.validate(async valid => {
        if (!valid) return;
        this.submitData = this.$_.cloneDeep(this.formData)
        if (this.beforeSubmit) {
          this.beforeSubmit()
        }
        if (this.isEdit) {
          await this.editApi(this.submitData)
        } else {
          await this.adddApi(this.submitData)
        }
        Tips.message({
          message: this.isEdit ? this.editSuccessMsg : this.addSuccessMsg,
          type: 'success'
        })
        this.showFormDialog = false
        this.$refs.dataTable.refresh()
      })
    },

    async doDelete(id) {
      await this.$confirm(
        '确定删除该条记录？',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      let params = {
        [this.deleteKey]: id
      }
      if (this.customDeleteParams) {
        params = this.customDeleteParams(id)
      }
      await this.deleteApi(params)
      Tips.message({
        message: this.deleteSuccessMsg,
        type: 'success'
      })
      if (this.afterDoDelete) {
        this.afterDoDelete(id)
      } else {
        this.$refs.dataTable.refresh()
      }
    },
  }
};
